import { useState } from 'react';
import { SettingsInterface } from './Interface';
import type { SettingsContainerProps, SettingsTabId } from './types';

/**
 * Settings feature logic: active tab state.
 * Game tool actions are owned by the app shell and passed through as props.
 */
export default function SettingsContainer(props: SettingsContainerProps) {
  const [activeTab, setActiveTab] = useState<SettingsTabId>('game');

  return <SettingsInterface {...props} activeTab={activeTab} onTabChange={setActiveTab} />;
}
